<template>
  <div class="col-3 position-absolute top-0 end-0 z-index--200">
    <div class="ratio ratio-1x1">
      <img
        src="../../assets/images/landing/1.png"
        alt="background-symbol-image"
      />
    </div>
  </div>
  <div class="col-3 position-absolute top-45 start-0 z-index--200">
    <div class="ratio ratio-1891x2633">
      <img
        src="../../assets/images/price/2.png"
        alt="background-symbol-image"
      />
    </div>
  </div>
  <div class="col-5 position-absolute bottom-0 start-0 z-index--200">
    <div class="ratio ratio-1x1">
      <img src="../../assets/images/blog/3.svg" alt="background-symbol-image" />
    </div>
  </div>
  <div class="font-merriweather-sans">
    <the-remarkable-insights-section />
    <background-card />
  </div>
</template>
<script>
export default {
  name: "Blog",
};
</script>
<script setup>
import BackgroundCard from "@/components/blog/index/BackgroundCard";
import TheRemarkableInsightsSection from "@/components/blog/index/TheRemarkableInsightsSection";
</script>

<style scoped></style>
